import React from 'react';
import { red, blue } from '@mui/material/colors';
import {
	Typography,
	Card,
	Box,
	container,
	Grid,
	Paper,
	Button,
} from '@mui/material';

import ProgramItemList from './ProgramItemList';
import Footer from './Foot';
import ProgramAccordions from './ProgramAccordion';
import basketBallImage from '../images/pexels-monstera.jpeg';
import MeetingImage from '../images/meeting.jpeg'
import Youth from '../images/youth.jpeg'


import '../styles/program.css';
import _ from 'lodash';

const programs = [
	{
		id: 1,
		title: 'PhotoVoice',
		content: `PhotoVoice uses community-based participatory research that allows the at-risk youth to
		capture and discuss their own reality of gun related violence from the perspective of a victim or
		that of a vulnerable youth attracted to a violent lifestyle.
		Twenty-five youth will be invited to participate in the PhotoVoice project. A professional
		photographer will train and coach them on how to compose photos that represent the gun
		violence they experience in their day-to-day lives; for example, certain people or streetscapes.
		These photos inform and/or validate the youths’ opinions about issues surrounding gun
		violence. A public exhibition provides opportunity for these purposeful photographers to share
		as the photos can act as catalysts for meaningful discussions about the impact of gun violence
		and possible solutions.
		The program will run for 3 months from March to May every year, with creative and technical
		support from a professional photographer (s) carefully chosen for their understanding of the
		purpose of the project and the participants themselves.`,
		image: Youth,
	},
	{
		id: 2,
		title: 'Town Hall Meetings',
		content: `Town Hall Meetings for youth and their families provide a safe space to share their concerns
		about gun violence, offer ideas for solutions and listen to experts with experience on
		
		successfully tackling this significant issue at the family level. YECO is planning a series of three
		Town Hall Meetings between September and December 2023 (every year). Robust promotion of
		the events will result in at least 100 people at each meeting, with a representation from at least
		40 families.`,
		image:  MeetingImage,
	},
	{
		id: 3,
		title: 'Basketball Tournament',
		content: `Participation in sports is a popular and effective vehicle for community engagement and
		outreach for youth experiencing or at-risk of involvement with gun violence. There are several
		sport programs across the city for these youth; however, even a nominal fee is prohibitive for
		low income families.
		In order to bridge the gap, YECO will offer a free, safe space in a basketball program that will
		include at least 30 teams across the City. Each team will accommodate at least 15-20 members
		so it is possible to engage 500-800 youth in total. The tournament will take place between June
		and August 2023 (every year). This large number of participants is a critical mass to engage
		and educate about the indicators and impact of gun violence in each of their communities. This
		connection can, in turn, lead to youth-developed strategic solutions.`,
		image: basketBallImage,
	},
];

function Program() {
	return (
		<div style={{height:"fit-content", display:"flex", flexDirection:"column",justifyContent:"flex-end"}}>
			<Grid
				justifyContent="center"
				alignItems="center"
				direction="column"
				container
				sx={{background:'hsl(0, 0%, 98%)'}}
			>
				<Box
					style={{
						height: '120px',
						background: 'rgb(0,25,175,.5)',
						width: '100%',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						color: 'rgb(0,25,175,.5)',
						paddingTop: '48px',
					}}
				>
					<Typography
						variant="h4"
						color="hsl(0, 0%, 98%)"
						fontWeight="700"
						fontFamily="epilogue"
					>
						Our Programs
					</Typography>
				</Box>

				<ProgramAccordions programs={programs} />

			</Grid>
			<Box sx={{width:'100vw',background:"#C6C6C6"}}>
			<Footer  />
			</Box>
			
		</div>
	);
}

export default Program;
